const OUTLINER_ICONS = {
  camera: '/maya-icons/out_camera.png',
  transform: '/maya-icons/out_transform.png',
  group: '/maya-icons/out_transform.png',
  mesh: '/maya-icons/out_mesh.png',
  set: '/maya-icons/out_objectSet.png',
  reference: '/maya-icons/out_reference.png',
  about: '/maya-icons/out_transform.png',
  nurbsCurve: '/maya-icons/out_nurbsCurve.png',
}

const OUTLINER_CAMERA_SCALE = 1.25
const OUTLINER_CAMERA_BASE_HEIGHT = 14

const MayaOutlinerIcon = ({ type, size = 'default', className = '' }) => {
  const src = OUTLINER_ICONS[type] || OUTLINER_ICONS.transform
  const isCamera = type === 'camera'
  const baseHeight = size === 'small' ? OUTLINER_CAMERA_BASE_HEIGHT : 20
  const pixelHeight =
    size === 'small' && isCamera
      ? baseHeight * OUTLINER_CAMERA_SCALE
      : size === 'small'
        ? baseHeight
        : 20
  const pixelWidth = isCamera ? Math.round(pixelHeight * 1.6) : pixelHeight

  return (
    <img
      src={`${process.env.PUBLIC_URL}${src}`}
      alt=""
      width={pixelWidth}
      height={pixelHeight}
      className={[
        'maya-outliner-icon',
        size === 'small' ? 'is-small' : '',
        type === 'camera' ? 'is-camera' : '',
        type === 'set' || type === 'reference' ? 'is-set' : '',
        type === 'reference' ? 'is-reference' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
      draggable={false}
    />
  )
}

export default MayaOutlinerIcon
